import { Component, OnInit } from '@angular/core';
import { BaseComponent } from "@bt/core/base";
import { GeoModel, GeoService } from "@bt/core";
import { NotifierService } from "angular-notifier";
import { Router, ActivatedRoute } from "@angular/router";
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import { NgbModal,NgbActiveModal,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { DeleteUserModalContent } from '@bt/admin/all-users/delete-users-modal';


@Component({
  selector: 'app-geo',
  templateUrl: './geo.component.html',
  styleUrls: ['./geo.component.scss']
})
export class GeoComponent extends BaseComponent implements OnInit {

  public modalRef: NgbModalRef;
  faPencilAlt = faPencilAlt;

  public isResponsed: boolean = false;
  public hasInfo:boolean = false;
  public geos: any[];
  public isSmthChecked: boolean;

  notifier: any;

  constructor(
    private geoService: GeoService,
    notifierService: NotifierService,
    private modalService: NgbModal,
    private router: Router,
  ) {
    super();
    this.notifier = notifierService;
   }

  ngOnInit() {
    this.geos = new Array<GeoModel>();
    this.GetGeo();
  }

  GetGeo(){
    this.setLoading(true);
    this.geoService.GetGeos()
    .then((resp) => {
      this.geos = resp.data;
      this.hasInfo = resp.data.length != 0;
      this.isResponsed = true;
      this.setLoading(false);
    })
    .catch((error)=>{
      this.notifier.notify('error', "Ошибка при получении Гео");
      this.hasInfo = false;
      this.isResponsed = true;
      this.setLoading(false);
    });
  }

  public goEditGeo(id:string){
    if(!!id) this.router.navigateByUrl('app/geoeditor/' + id);
     else this.router.navigateByUrl('app/newgeo');
  }

  public isChecked()
  {
    this.isSmthChecked = false;
    this.geos.forEach(temp => {
      if (temp.isDeleted == true)
      {
        this.isSmthChecked = true;
      }
    });
    return this.isSmthChecked;
  }

  public openDeleteGeos(){
    let t=this;
    t.modalRef = t.modalService.open(DeleteUserModalContent,
      {
        backdropClass: 'light-white-backdrop',
        centered: true ,
        size: 'sm',
        windowClass:'super-modal-delete-users very-nice-shadow',

      });
      t.modalRef.componentInstance.isNeedDelete=false;
      t.modalRef.componentInstance.title = "Удаление";
      t.modalRef.componentInstance.description="Вы действительно хотите удалить отмеченное?";
      t.modalRef.componentInstance.button = "Удалить";
      t.modalRef
      .result.then((result)=>{
        this.setLoading(true);
        if(result){
          var geosToDelete = [];
          for(var i=0; i<t.geos.length;i++){
            if(t.geos[i].isDeleted){
              geosToDelete.push(t.geos[i]);
            }
          }

          t.geoService.DeleteGeos(geosToDelete)
          .then((resp) => {
            if (resp.data == true) {
              t.notifier.notify('success', "Успешно удалено");
              this.GetGeo();
            }
            this.setLoading(false);
          })
          .catch((error) => {
            t.notifier.notify('error', 'Ошибка удаления Гео');
            this.setLoading(false);
        //console.error(error.error);
          });
        }


      },
      (reason) => {
        //если отменили нажали на крестик или мимо окна
      })
  }

}



// WEBPACK FOOTER //
// ./src/app/geo/geo.component.ts